type TaskStatusFilter = 'todo' | 'overdue' | 'completed'

export type TaskListFilters = {
  user?: string
  type?: string
  status?: string
  contacts?: string
  applicants?: string
  agency?: string
  createdBy?: string
  completedBy?: string
  linkedTo?: string
  dueAfter?: string
  dueBefore?: string
}

export type TaskLinkedTo = 'applicant' | 'contact' | 'none'

export const taskLinkedToLabels: Record<TaskLinkedTo, string> = {
  applicant: 'Candidat',
  contact: 'Contact',
  none: 'Aucun'
}

export const taskStatusLabels: Record<TaskStatusFilter, string> = {
  todo: 'À faire',
  overdue: 'En retard',
  completed: 'Terminées'
}

/** Tabs of the tasks page: open tasks grouped by due date, or treated ones by treatment date. */
export type TaskView = 'todo' | 'done'
